import { Box, Stack, Typography, useTheme } from "@mui/material";
import {
  Avatar,
  AvatarGroup,
  Button,
  HoverableMenu,
  SingleUserIcon,
  UserGroupIcon,
  UserPlusIcon,
} from "components";
import { useAtomValue, useSetAtom } from "jotai";
import React, { useEffect, useState } from "react";
import { AssignTeammatesDrawer } from "shared/features/assignees";
import {
  assigneeData,
  setAssigneeData,
  setAssignMe,
} from "../store/newTicketStore";
import { OnSubmitReturnType } from "shared/features/assignees/type/assigneeType";
import { addMixpanelEvent, getFullName } from "utilz/helpers";
import { addAssignee } from "shared/features/assignees/store/assigneeStore";
import { v4 as uuid } from "uuid";
import { useGlobalStore } from "controller";
import toast from "react-hot-toast";
export const TicketAssigneeButton = ({
  customerId,
  isRecurring = false,
}: {
  customerId?: string;
  /** When true, opens the recurring-ticket variant of the assignees drawer. */
  isRecurring?: boolean;
}) => {
  const [open, setOpen] = React.useState(false);
  const assignees = useAtomValue(assigneeData);
  const saveAssigneeToStore = useSetAtom(setAssigneeData);
  const resourceInfo = useGlobalStore((state) => state);
  const [showAssignMe, setShowAssignMe] = useState(false);
  const assignMe = useSetAtom(setAssignMe);
  const handleSaveClick = ({ apiData, tableData }: OnSubmitReturnType) => {
    saveAssigneeToStore({ apiData, tableData });
    setOpen(false);
  };
  const [showAssignDropDown, setShowAssignDropDown] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    setShowAssignMe(assignees.apiData.new.length <= 0);
  }, [assignees.apiData.new.length]);

  useEffect(() => {
    setShowAssignDropDown(assignees.apiData.new.length <= 0);
  }, [assignees.apiData.new.length]);

  const onDropDownMenuClick = async (value: any, name: any) => {
    if (value == "assignToTeam") {
      addMixpanelEvent({
        event: "create_ticket_assign_team",
      });
      setOpen(true);
    } else if (value == "assignToMe") {
      const checkAllReadyExist = assignees.tableData.some((item) => {
        return item.resource_id == resourceInfo.resourceId;
      });
      if (checkAllReadyExist) {
        toast.error("You are already assigned to this ticket");
        return;
      }
      addMixpanelEvent({
        event: "create_ticket_assign_me",
      });
      try {
        assignMe({
          resourceId: resourceInfo.resourceId || "",
          firstName: resourceInfo.firstName || "",
          lastName: resourceInfo.lastName || "",
          profilePic: resourceInfo.profilePictureUrl || "",
        });
      } catch (error: any) {
        toast.error(error?.message || "Unable to assign me");
      }
    }
  };

  return (
    <Stack direction={"row"} gap={"24px"}>
      {/* <Stack direction={"row"} gap={"8px"}>
        {
          <Button
            variant="secondary"
            disabled={!customerId}
            startIcon={<SingleUserIcon />}
            onClick={() => {
              setOpen(true);
              addMixpanelEvent({
                event: "create_ticket_assign_team",
              });
            }}
          >
            Assignee
          </Button>
        }
        {showAssignMe && (
          <Button
            variant="ghost"
            disabled={!customerId}
            onClick={() => {
              assignMe({
                resourceId: resourceInfo.resourceId || "",
                firstName: resourceInfo.firstName || "",
                lastName: resourceInfo.lastName || "",
                profilePic: resourceInfo.profilePictureUrl || "",
              });
              addMixpanelEvent({
                event: "ticket_assign_me",
              });
            }}
          >
            Assign To Me
          </Button>
        )}
      </Stack> */}
      {customerId ? (
        <HoverableMenu
          options={[
            {
              value: "assignToMe",
              name: "Assign to me",
              avatar: true,
              avatarData: {
                full_name:
                  resourceInfo?.firstName + " " + resourceInfo?.lastName || "",
                profile_image: resourceInfo.profilePictureUrl || "",
              },
              disabled: assignees.tableData.some(
                (item) => item.resource_id == resourceInfo.resourceId,
              ),
            },
            {
              value: "assignToTeam",
              name: "Assign to teammates",
              icon: <UserGroupIcon fontSize="small" />,
            },
          ]}
          onOptionClick={({ value, name }: any) => {
            onDropDownMenuClick(value, name);
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "9px",
              cursor: "pointer",
              padding: "5px 15px 6px 13px",
              borderRadius: "4px",
              transition: "background-color 0.2s, border-color 0.2s",
              "&:hover": {
                backgroundColor: theme.palette.neutral["010"],
                border: `1px solid ${theme.palette.neutral["020"]}`,
              },
              // border: "1px solid transparent",
              border: `1px solid ${theme.palette.neutral["020"]}`,
            }}
          >
            <UserPlusIcon sx={{ fontSize: "18px" }} />
            <Typography variant="body-medium" sx={{ fontWeight: 600 }}>
              Assignees
            </Typography>
            {/* {assigneeLength > 0 ? <BadgeComponent /> : null} */}
          </Box>
        </HoverableMenu>
      ) : (
        <Button
          variant="secondary"
          disabled={!customerId}
          startIcon={<SingleUserIcon />}
          onClick={() => {
            setOpen(true);
            addMixpanelEvent({
              event: "create_ticket_assign_team",
            });
          }}
        >
          Assignee
        </Button>
      )}

      <AvatarGroup childWidthHeight="28px" max={2}>
        {assignees.apiData.new.map((item, index) => {
          const fullname = getFullName(item.first_name, "", item.last_name);
          return (
            <Avatar
              key={index}
              variants="md"
              tooltip
              fullname={fullname}
              url={item.profile_image}
            />
          );
        })}{" "}
      </AvatarGroup>
      {open && (
        <AssignTeammatesDrawer
          open={open}
          onClose={() => setOpen(false)}
          mode="assign"
          // Recurring tickets stay selection-only (parity with the legacy
          // RecurringAssigneesDrawer); normal tickets get full per-assignee
          // scheduling (parity with the legacy AssigneesDrawer).
          enableScheduling={!isRecurring}
          tableData={assignees.tableData}
          onSave={handleSaveClick}
          customerId={customerId}
          serviceType={"tickets"}
        />
      )}
    </Stack>
  );
};
